import { type FC, type ReactNode } from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  type DialogProps,
} from '@mui/material';

import { type ConfirmationProps } from '#packages/web/types/confirmation-props';

export type DiscardChangesConfirmationDialogProps = DialogProps &
  ConfirmationProps & {
    dialogTitle?: ReactNode;

    dialogContent?: ReactNode;

    confirmButtonLabel?: ReactNode;
    cancelButtonLabel?: ReactNode;
  };

export const DiscardChangesConfirmationDialog: FC<
  DiscardChangesConfirmationDialogProps
> = ({
  onConfirm,
  onCancel,

  dialogTitle = 'Discard Changes',
  dialogContent,

  cancelButtonLabel = 'Keep Editing',
  confirmButtonLabel = 'Discard Changes',

  ...props
}) => (
  <Dialog maxWidth="xs" {...props}>
    <DialogTitle>{dialogTitle}</DialogTitle>
    <DialogContent>
      <Stack spacing={2}>
        <Typography typography="body1">
          Are you sure you want to discard your changes?
        </Typography>
        <Alert severity="warning">This action cannot be undone.</Alert>
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button autoFocus onClick={onCancel}>
        {cancelButtonLabel}
      </Button>
      <Button onClick={onConfirm} color="error">
        {confirmButtonLabel}
      </Button>
    </DialogActions>
  </Dialog>
);
